import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import createApp from "./app";

import "common.css";

const Root = () => (
  <BrowserRouter>
    {createApp({
      state: window.__INITIAL__STATE__,
      props: window.__INITIAL__PROPS__
    })}
  </BrowserRouter>
);

ReactDOM.render(<Root />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js